'use client';
import { makeStyles } from "@griffel/react";
import { typographyStyles } from "@fluentui/react-theme";
export const subtitle1ClassNames = {
    root: 'fui-Subtitle1'
};
/**
 * Styles for the root slot
 */ export const useSubtitle1Styles = makeStyles({
    root: typographyStyles.subtitle1
});
